export function midiToFrequency(midiNote: number) {
  return 440 * Math.pow(2, (midiNote - 69) / 12);
}
